<template>
    <v-container
        fluid
    >
        <v-row
            align="start"
        >
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">My Profile</v-col>
                        <v-col class="shrink">
                            <v-btn-toggle tile group>
                                <v-btn
                                    text
                                    dark
                                    small
                                    @click="PrintCard"
                                >
                                    <v-icon class="mr-2">mdi-id-card</v-icon>View Card
                                </v-btn>
                                <v-btn
                                    @click="PrintID"
                                    text
                                    dark
                                    small
                                    class="d-none"
                                >
                                    <v-icon class="mr-2">mdi-smart-card</v-icon>View I.D.
                                </v-btn>
                                <v-btn color="white" text light @click="ResetAll" small><v-icon class="mr-2">mdi-refresh</v-icon>Reset</v-btn>
                                <v-btn color="white" text light @click="SaveProcess" :disabled="SaveProcessDisabled()" small><v-icon class="mr-2">mdi-content-save-edit</v-icon>Save</v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </v-alert>

                <v-progress-linear
                    :value="profileperc"
                    height="40"
                    class="mb-4"
                    color="green darken-2"
                    dark
                >
                    Your profile is {{ Math.ceil(profileperc) }}% complete
                </v-progress-linear>

                <div class="d-none">
                    <img class="img-fluid" :src="profilepic" @load="LoadedProfilePic">
                    <img class="img-fluid" :src="valididpic" @load="LoadedValidId">
                </div>

                <v-tabs
                    centered
                    icons-and-text
                    background-color="red darken-1"
                    dark
                    v-model="active_tab"
                    @change="MapInvalidateSize"
                    show-arrows
                >
                    <v-tab>
                        Citizen Info
                        <v-icon left>mdi-account</v-icon>
                    </v-tab>
                    <v-tab>
                        Change Password
                        <v-icon left>mdi-lock</v-icon>
                    </v-tab>
                    <v-tab>
                        Address Details
                        <v-icon left>mdi-home-map-marker</v-icon>
                    </v-tab>
                    <v-tab>
                        Other Info
                        <v-icon left>mdi-information-outline</v-icon>
                    </v-tab>
                    <v-tab>
                        Signature
                        <v-icon left>mdi-signature-freehand</v-icon>
                    </v-tab>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            label="* Username"
                                            type="text"
                                            v-model="citizen.username"
                                            :background-color="AmIMissing(citizen.username)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* First Name"
                                            type="text"
                                            v-model="citizen.firstname"
                                            ref="citfirstname"
                                            @keyup="FullnameFormat"
                                            @blur="citizen.firstname = StartCase(citizen.firstname)"
                                            :background-color="AmIMissing(citizen.firstname)"
                                        ></v-text-field>
                                    </v-col>
                                    
                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* Middle Name"
                                            type="text"
                                            v-model="citizen.middlename"
                                            @keyup="FullnameFormat"
                                            @blur="citizen.middlename = StartCase(citizen.middlename)"
                                            :background-color="AmIMissing(citizen.middlename)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* Last Name"
                                            type="text"
                                            v-model="citizen.lastname"
                                            @keyup="FullnameFormat"
                                            @blur="citizen.lastname = StartCase(citizen.lastname)"
                                            :background-color="AmIMissing(citizen.lastname)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="Extension Name (e.g. Jr., Sr., III)"
                                            type="text"
                                            v-model="citizen.extensionname"
                                            @keyup="FullnameFormat"
                                            @blur="citizen.extensionname = StartCase(citizen.extensionname)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        class="d-none"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="Full Name Format 1"
                                            type="text"
                                            v-model="citizen.fullname_format1"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        class="d-none"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="Full Name Format 2"
                                            type="text"
                                            v-model="citizen.fullname_format2"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <vue-tel-input
                                            v-model="citizen.mobile"
                                            defaultCountry="PH"
                                            placeholder="* Enter your Mobile #"
                                            autocomplete="off"
                                            @validate="PhoneNumberUpdate"
                                        ></vue-tel-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-select
                                            :items="genders"
                                            label="* Gender"
                                            item-text="text"
                                            item-value="value"
                                            v-model="citizen.gender"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-dialog
                                            ref="dialog"
                                            v-model="birthdatemodal"
                                            :return-value.sync="citizen.birthdate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="citizen.birthdate"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    label="* Birthdate"
                                                    disabled
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="citizen.birthdate"
                                                scrollable
                                                :max="maxDate"
                                                color="green darken-3"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="red darker-3" @click="birthdatemodal = false">Cancel</v-btn>
                                                <v-btn text color="green darker-3" @click="$refs.dialog.save(citizen.birthdate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* Birth Place"
                                            type="text"
                                            v-model="citizen.birthplace"
                                            :background-color="AmIMissing(citizen.birthplace)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* Email Address"
                                            type="text"
                                            v-model="citizen.email"
                                            :background-color="AmIMissing(citizen.email)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                        class="d-none"
                                    >
                                        <v-text-field
                                            label="Fathers Name"
                                            type="text"
                                            v-model="citizen.fathers_name"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                        class="d-none"
                                    >
                                        <v-text-field
                                            label="Mothers Maiden Name"
                                            type="text"
                                            v-model="citizen.mothers_maiden_name"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="Nationality"
                                            type="text"
                                            v-model="citizen.nationality"
                                            :background-color="AmIMissing(citizen.nationality)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-select
                                            :items="civil_statuses"
                                            label="Civil Status"
                                            item-text="text"
                                            item-value="value"
                                            v-model="citizen.civil_status"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.civil_status.toString().toUpperCase() == 'M' && citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="* Spouse Name"
                                            type="text"
                                            v-model="citizen.spousename"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="Occupation"
                                            type="text"
                                            v-model="citizen.occupation"
                                            :background-color="AmIMissing(citizen.occupation)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="* Company Name"
                                            type="text"
                                            v-model="citizen.companyname"
                                            :background-color="AmIMissing(citizen.companyname)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="* Type of Business"
                                            type="text"
                                            v-model="citizen.businesstype"
                                            :background-color="AmIMissing(citizen.businesstype)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <vue-tel-input
                                            v-model="citizen.mobile"
                                            defaultCountry="PH"
                                            placeholder="* Contact Number/Telephone Number"
                                            autocomplete="off"
                                            @validate="PhoneNumberUpdate"
                                        ></vue-tel-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="* Email Address"
                                            type="text"
                                            v-model="citizen.email"
                                            :background-color="AmIMissing(citizen.email)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-dialog
                                            ref="dialog"
                                            v-model="dateestablishedmodal"
                                            :return-value.sync="citizen.date_established"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="citizen.date_established"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    label="Date Established"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="citizen.date_established"
                                                scrollable
                                                :max="maxDate"
                                                color="green darken-3"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="red darker-3" @click="dateestablishedmodal = false">Cancel</v-btn>
                                                <v-btn text color="green darker-3" @click="$refs.dialog.save(citizen.date_established)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="TIN #"
                                            type="text"
                                            v-model="citizen.tin"
                                            :background-color="AmIMissing(citizen.tin)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-alert type="info">Company Representative</v-alert>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="* Name"
                                            type="text"
                                            v-model="citizen.representative.name"
                                            :background-color="AmIMissing(citizen.representative.name)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <vue-tel-input
                                            v-model="citizen.representative.contactnumber"
                                            defaultCountry="PH"
                                            placeholder="* Contact Number/Telephone Number"
                                            autocomplete="off"
                                            @validate="PhoneNumberUpdateRep"
                                        ></vue-tel-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="6"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-text-field
                                            label="* Email Address"
                                            type="text"
                                            v-model="citizen.representative.email"
                                            :background-color="AmIMissing(citizen.representative.email)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-file-input
                                            label="Upload your Photo"
                                            outlined
                                            dense
                                            show-size accept="image/jpeg, image/png"
                                            @change="FileAttachment"
                                            v-model="citizen.cphoto"
                                            prepend-inner-icon="mdi-file-find-outline"
                                            chips
                                            small-chips
                                            counter
                                            class="mt-3"
                                        ></v-file-input>

                                        <v-btn
                                            text
                                            @click="ViewProfilePhoto(citizen.imgUrl)"
                                            v-if="citizen.imgUrl && profilepicloaded"
                                        >
                                            View Photo
                                        </v-btn>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-file-input
                                            label="Upload a Valid I.D."
                                            outlined
                                            dense
                                            show-size accept="image/jpeg, image/png"
                                            @change="FileAttachmentValidId"
                                            v-model="citizen.cphotovalidid"
                                            prepend-inner-icon="mdi-file-find-outline"
                                            chips
                                            small-chips
                                            counter
                                            class="mt-3"
                                        ></v-file-input>

                                        <v-btn
                                            text
                                            @click="ViewProfilePhoto(citizen.imgUrlValidId)"
                                            v-if="citizen.imgUrl && valididpicloaded"
                                        >
                                            View Valid I.D.
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                            :prepend-inner-icon="'mdi-lock'"
                                            :type="showPass ? 'text' : 'password'"
                                            v-model="password"
                                            label="New Password"
                                            @click:append="showPass = !showPass"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :prepend-inner-icon="'mdi-lock-outline'"
                                            :type="showPass2 ? 'text' : 'password'"
                                            v-model="confirmpassword"
                                            label="Confirm New Password"
                                            @click:append="showPass2 = !showPass2"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-btn
                                            block
                                            color="red darken-2"
                                            dark
                                            elevation="6"
                                            @click="ChangeMyPassword"
                                        >Change Password</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col
                                        cols="12"
                                    >
                                        <v-checkbox
                                            v-model="citizen.tugueresident"
                                            label="Are you a Tuguegarao Resident? uncheck if not."
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="text-h5 p-2 d-none"
                                    >
                                        <v-row>
                                            <v-col
                                                cols="3"
                                            >
                                                <v-switch
                                                    v-model="citizen.address.permanent.istugue"
                                                    label="Tuguegarao Address"
                                                    @change="PermanentAddressChange"
                                                    color="red darken-2"
                                                    inset
                                                ></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="subtitle-1"
                                    >
                                        Tuguegarao Address
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        :lg="citizen.address.permanent.istugue ? 6 : 4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Address 1"
                                            type="text"
                                            v-model="citizen.address.permanent.address1"
                                            :background-color="AmIMissing(citizen.address.permanent.address1)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        :lg="citizen.address.permanent.istugue ? 6 : 4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="Address 2"
                                            type="text"
                                            v-model="citizen.address.permanent.address2"
                                            :background-color="AmIMissing(citizen.address.permanent.address2)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        :lg="citizen.address.permanent.istugue ? 6 : 4"
                                        :class="citizen.address.permanent.istugue ? '' : 'd-none'"
                                    >
                                        <v-text-field
                                            label="* Street Address"
                                            type="text"
                                            v-model="citizen.address.permanent.street"
                                            :background-color="AmIMissing(citizen.address.permanent.street)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        :lg="citizen.address.permanent.istugue ? 6 : 4"
                                        :class="citizen.address.permanent.istugue ? '' : 'd-none'"
                                    >
                                        <v-select
                                            :items="brgy"
                                            label="* Barangay"
                                            item-text="BarangayName"
                                            item-value="BarangayCode"
                                            v-model="citizen.address.permanent.brgy"
                                            @change="ReverseGeocoderPermanent"
                                            style="z-index: 999"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* City"
                                            type="text"
                                            v-model="citizen.address.permanent.city"
                                            :background-color="AmIMissing(citizen.address.permanent.city)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Province"
                                            type="text"
                                            v-model="citizen.address.permanent.province"
                                            :background-color="AmIMissing(citizen.address.permanent.province)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Country"
                                            type="text"
                                            v-model="citizen.address.permanent.country"
                                            :background-color="AmIMissing(citizen.address.permanent.country)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.permanent.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="ZIP Code"
                                            type="text"
                                            v-model="citizen.address.permanent.zipcode"
                                            :background-color="AmIMissing(citizen.address.permanent.zipcode)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <div style="height: 300px; width: 100%;">
                                            <l-map
                                                style="height: 300px; z-index: 1;"
                                                ref="myMap"
                                                @ready="onreadymap()"
                                                :center="center"
                                                :options="mapOptions"
                                                :zoom="citizen.address.permanent.zoom"
                                            >
                                                <l-tile-layer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    :attribution="attribution"
                                                />
                                                <l-marker :lat-lng.sync="citizen.address.permanent.latlng" draggable></l-marker>
                                            </l-map>
                                        </div>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-btn
                                            text
                                            color="orange darken-3"
                                            @click="CopyPermanentAddress"
                                        ><v-icon>mdi-content-copy</v-icon></v-btn>&nbsp;Same as Tuguegarao Address
                                    </v-col>

                                    <!-- Present Address -->

                                    <v-col
                                        cols="12"
                                        class="subtitle-1"
                                    >
                                        Present Address
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="text-h5 d-none"
                                    >
                                        <v-row>
                                            <v-col
                                                cols="3"
                                            >
                                                <v-switch
                                                    v-model="citizen.address.present.istugue"
                                                    label="Present Address"
                                                    @change="PresentAddressChange"
                                                    color="red darken-2"
                                                    inset
                                                ></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Address 1"
                                            type="text"
                                            v-model="citizen.address.present.address1"
                                            :background-color="AmIMissing(citizen.address.present.address1)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="Barangay"
                                            type="text"
                                            v-model="citizen.address.present.address2"
                                            hint="ignore if outside the Philippines"
                                            persistent-hint
                                            :background-color="AmIMissing(citizen.address.present.address2)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? '' : 'd-none'"
                                    >
                                        <v-text-field
                                            label="* Number/Street"
                                            type="text"
                                            v-model="citizen.address.present.street"
                                            :background-color="AmIMissing(citizen.address.present.street)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? '' : 'd-none'"
                                    >
                                        <v-select
                                            :items="brgy"
                                            label="* Barangay"
                                            item-text="BarangayName"
                                            item-value="BarangayCode"
                                            v-model="citizen.address.present.brgy"
                                            @change="ReverseGeocoderPresent"
                                            style="z-index: 999"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* City"
                                            type="text"
                                            v-model="citizen.address.present.city"
                                            :background-color="AmIMissing(citizen.address.present.city)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Province"
                                            type="text"
                                            v-model="citizen.address.present.province"
                                            :background-color="AmIMissing(citizen.address.present.province)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="* Country"
                                            type="text"
                                            v-model="citizen.address.present.country"
                                            :background-color="AmIMissing(citizen.address.present.country)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="6"
                                        lg="4"
                                        :class="citizen.address.present.istugue ? 'd-none' : ''"
                                    >
                                        <v-text-field
                                            label="ZIP Code"
                                            type="text"
                                            v-model="citizen.address.present.zipcode"
                                            :background-color="AmIMissing(citizen.address.present.zipcode)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="d-none"
                                    >
                                        <div style="height: 300px; width: 100%;">
                                            <l-map
                                                style="height: 300px;"
                                                ref="myMap2"
                                                @ready="onreadymap()"
                                                :center="center2"
                                                :options="mapOptions"
                                                :zoom="citizen.address.present.zoom"
                                            >
                                                <l-tile-layer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    :attribution="attribution"
                                                />
                                                <l-marker :lat-lng.sync="citizen.address.present.latlng" draggable></l-marker>
                                            </l-map>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                    >
                                        <v-text-field
                                            label="TIN #"
                                            type="text"
                                            v-model="citizen.tin"
                                            :background-color="AmIMissing(citizen.tin)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="4"
                                        lg="4"
                                        v-if="citizen.accounttype.toString() == 'individual'"
                                        class="d-none"
                                    >
                                        <v-text-field
                                            label="Educational Attainment"
                                            type="text"
                                            v-model="citizen.educational_attainment"
                                            :background-color="AmIMissing(citizen.educational_attainment)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-file-input
                                            label="SEC/DTI"
                                            outlined
                                            show-size accept="image/jpeg, image/png, application/pdf"
                                            @change="FileAttachmentSEC"
                                            v-model="citizen.secdti"
                                            prepend-inner-icon="mdi-file-find-outline"
                                            multiple
                                            chips
                                            small-chips
                                            counter
                                            class="mt-3"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="citizen.accounttype.toString() == 'corporation'"
                                    >
                                        <v-file-input
                                            label="Board Resolution Authorizing Company Representative"
                                            outlined
                                            show-size accept="image/jpeg, image/png, application/pdf"
                                            @change="FileAttachmentAuthRep"
                                            v-model="citizen.boardresolutionauthorizingrep"
                                            prepend-inner-icon="mdi-file-find-outline"
                                            multiple
                                            chips
                                            small-chips
                                            counter
                                            class="mt-3"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-alert type="info">In case of Emergency (Contact Person)</v-alert>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            label="Name"
                                            v-model="citizen.incaseofemergency.name"
                                            :background-color="AmIMissing(citizen.incaseofemergency.name)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            label="Address"
                                            v-model="citizen.incaseofemergency.address"
                                            :background-color="AmIMissing(citizen.incaseofemergency.address)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                    >
                                        <v-text-field
                                            label="Contact Number"
                                            v-model="citizen.incaseofemergency.contactnumber"
                                            :background-color="AmIMissing(citizen.incaseofemergency.contactnumber)"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row dense>
                                    <v-col
                                        cols="12"
                                    >
                                        <v-switch
                                            v-model="uploadsignature"
                                            label="Upload Signature"
                                            inset
                                            @change="LoadSig"
                                        ></v-switch>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="uploadsignature"
                                    >
                                        <v-file-input
                                            label="Upload your Signature"
                                            outlined
                                            dense
                                            show-size accept="image/jpeg, image/png"
                                            @change="FileAttachmentUploadedSignature"
                                            v-model="citizenssignature"
                                            prepend-inner-icon="mdi-file-find-outline"
                                            chips
                                            small-chips
                                            counter
                                            class="mt-3"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="!uploadsignature"
                                    >
                                        <v-btn
                                            text
                                            @click="UndoSig"
                                            color="orange darker-4"
                                        >
                                            <v-icon class="mr-2">mdi-undo-variant</v-icon>Undo
                                        </v-btn>

                                        <v-btn
                                            text
                                            @click="ClearSig"
                                            color="red darker-4"
                                        >
                                            <v-icon class="mr-2">mdi-trash-can-outline</v-icon>Clear
                                        </v-btn>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        v-if="!uploadsignature"
                                    >
                                        <VueSignaturePad width="640px" height="360px" ref="signaturePad" style="border: 2px solid #000; display: table; margin: 0 auto;" />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>

        <v-snackbar
            v-model="showSnackbar"
            :color="snackbarVariant"
            :timeout="3000"
            :top="'top'"
            centered
            elevation="24"
            style="z-index: 9999"
            class="mt-6"
        >
            <v-layout color="transparent" dark>{{ modalMessage }}</v-layout>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="showSnackbar = false"
                >
                    <i class="mdi mdi-close"></i>
                </v-btn>
            </template>
        </v-snackbar>

        <v-overlay :value="overlay" style="z-index: 2000;">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <LightBox
            ref="lightbox"
            :media="lightboxmedia"
            :show-caption="false"
            :show-light-box="false"
        />

        <v-dialog
            v-model="cropsigform"
            scrollable
            max-width="1000"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="headline grey lighten-5 black--text"><i class="mdi mdi-crop mr-2"></i>Crop Signature</v-card-title>
                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-col
                        cols="12"
                    >
                        <cropper
                            class="cropper"
                            :src="citizenssignaturedata"
                            :stencil-props="{
                                aspectRatio: 16/9
                            }"
                            @change="CropPhotoSignature"
                        ></cropper>
                    </v-col>
                </v-card-text>

                <v-card-actions
                    class="grey lighten-5"
                >
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-3" text @click="SelectCroppedSignaturePhoto">
                        <v-icon class="mr-2">mdi-crop</v-icon>Crop Photo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="cropform"
            scrollable
            max-width="1000"
            overlay-opacity="0.7"
            persistent
        >
            <v-card>
                <v-card-title class="headline grey lighten-5 black--text"><i class="mdi mdi-crop mr-2"></i>Crop Photo</v-card-title>
                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-col
                        cols="12"
                    >
                        <cropper
                            v-if="citizen.cphoto"
                            class="cropper"
                            :src="citizen.cphotodata"
                            :stencil-props="{
                                aspectRatio: 2/2
                            }"
                            @change="CropPhoto"
                        ></cropper>
                    </v-col>
                </v-card-text>

                <v-card-actions
                    class="grey lighten-5"
                >
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-3" text @click="SelectCroppedPhoto">
                        <v-icon class="mr-2">mdi-crop</v-icon>Crop Photo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="pdf.show"
            scrollable
            max-width="1080"
            overlay-opacity="0.2"
            persistent
            style="z-index: 9999;"
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-pdf-outline mr-2"></i>PDF Viewer</v-card-title>

                <v-card-text
                    id="pdfcard"
                >
                    <PDF
                        ref="pdfviewer"
                        v-if="pdf.show"
                        :src="pdf.media"
                        @num-pages="pdf.pageCount = $event"
                        @page-loaded="PDFLoaded($event)"
                    ></PDF>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        dark
                        @click="PDFtoImage"
                        v-if="pdfloaded"
                    >
                        Download
                    </v-btn>

                    <v-btn
                        text
                        dark
                        @click="$refs.pdfviewer.print()"
                        v-if="pdfloaded"
                    >
                        Print
                    </v-btn>

                    <v-btn 
                        text
                        dark
                        @click="pdf.show = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from "axios"
import moment from "moment"
import _ from 'lodash'
import { Icon } from 'leaflet'
import { LMap, LTileLayer, LMarker } from "vue2-leaflet"
import 'leaflet/dist/leaflet.css'
import { Nominatim } from 'nominatim-geocoder'
import LightBox from 'vue-image-lightbox'
import { Cropper } from 'vue-advanced-cropper'
import PDF from 'vue-pdf'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    name: 'profile',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - My Profile',
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LightBox,
        Cropper,
        PDF,
    },
    data() {
        return {
            uploadsignature: false,
            citizenssignature: undefined,
            citizenssignaturedata: '',
            pdfloaded: false,
            pdf: {
                show: false,
                media: [],
                currentPage: 0,
                pageCount: 0,
            },
            croppedphoto: {
                coordinates: undefined,
                dataurl: undefined,
            },
            croppedsigphoto: {
                coordinates: undefined,
                dataurl: undefined,
            },
            cropsigform: false,
            cropform: false,
            profilepic: '',
            valididpic: '',
            profilepicloaded: false,
            valididpicloaded: false,
            profileperc: 0,
            lightboxmedia: [],
            dateestablishedmodal: false,
            CRM_Interval: null,
            maxDate: moment().toISOString().substr(0, 10),
            genders: [
                {
                    text: 'Male',
                    value: 'm'
                },
                {
                    text: 'Female',
                    value: 'f'
                }
            ],
            civil_statuses: [
                {
                    text: 'Single',
                    value: 'S'
                },
                {
                    text: 'Married',
                    value: 'M'
                }
            ],
            birthdatemodal: false,
            citizenreset: {},
            citizen: {
                cphotovalidid: undefined,
                cphotovalididdata: '',
                cphoto: undefined,
                cphotodata: '',
                accounttype: 'individual',
                citizen_id: '',
                username: '',
                firstname: '',
                lastname: '',
                middlename: '',
                fullname_format1: '',
                fullname_format2: '',
                gender: 'm',
                birthdate: 0,
                mobile: '',
                mobilevalid: false,
                mobileformatted: '',
                email: '',
                address: {
                    permanent: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: true,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    },
                    present: {
                        street: '',
                        brgy: '',
                        city: 'Tuguegarao City',
                        province: 'Cagayan',
                        address1: '',
                        address2: '',
                        country: 'Philippines',
                        zipcode: 3500,
                        istugue: false,
                        latlng: [ 17.611138, 121.7257458 ],
                        zoom: 13
                    }
                },
                fathers_name: '',
                mothers_maiden_name: '',
                civil_status: 'S',
                nationality: 'Filipino',
                tin: '',
                // new
                birthplace: '',
                spousename: '',
                occupation: '',
                educational_attainment: '',
                extensionname: '',
                incaseofemergency: {
                    name: '',
                    address: '',
                    contactnumber: '',
                },
                companyname: '',
                businesstype: '',
                date_established: '',
                representative: {
                    name: '',
                    email: '',
                    contactnumber: '',
                    mobilevalid: false,
                    mobileformatted: '',
                },
                secdti: [],
                secdtidata: [],
                boardresolutionauthorizingrep: [],
                boardresolutionauthorizingrepdata: [],
                tugueresident: false,
            },
            brgy: [],
            showSnackbar: false,
            snackbarVariant: 'red darken-3',
            modalMessage: '',
            overlay: true,
            active_tab: 0,
            map: null,
            map2: null,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 13,
            center: [ 17.611138, 121.7257458 ],
            center2: [ 17.611138, 121.7257458 ],
            mapOptions: {
                zoomSnap: 0.5
            },
            password: '',
            confirmpassword: '',
            showPass: false,
            showPass2: false,
            signatureloaded: false,
        }
    },
    methods: {
        AmIMissing(str) {
            return str.toString().length > 0 ? undefined : `yellow lighten-2`
            // return str.toString().length > 0 ? undefined : undefined
        },
        ucwords (str) {
            //  discuss at: https://locutus.io/php/ucwords/
            // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
            // improved by: Waldo Malqui Silva (https://waldo.malqui.info)
            // improved by: Robin
            // improved by: Kevin van Zonneveld (https://kvz.io)
            // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
            // bugfixed by: Cetvertacov Alexandr (https://github.com/cetver)
            //    input by: James (https://www.james-bell.co.uk/)
            //   example 1: ucwords('kevin van  zonneveld')
            //   returns 1: 'Kevin Van  Zonneveld'
            //   example 2: ucwords('HELLO WORLD')
            //   returns 2: 'HELLO WORLD'
            //   example 3: ucwords('у мэри был маленький ягненок и она его очень любила')
            //   returns 3: 'У Мэри Был Маленький Ягненок И Она Его Очень Любила'
            //   example 4: ucwords('τάχιστη αλώπηξ βαφής ψημένη γη, δρασκελίζει υπέρ νωθρού κυνός')
            //   returns 4: 'Τάχιστη Αλώπηξ Βαφής Ψημένη Γη, Δρασκελίζει Υπέρ Νωθρού Κυνός'
            return (str + '')
                .replace(/^(.)|\s+(.)/g, function ($1) {
                return $1.toUpperCase()
                })
        },
        ucfirst (str) {
            //  discuss at: https://locutus.io/php/ucfirst/
            // original by: Kevin van Zonneveld (https://kvz.io)
            // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
            // improved by: Brett Zamir (https://brett-zamir.me)
            //   example 1: ucfirst('kevin van zonneveld')
            //   returns 1: 'Kevin van zonneveld'
            str += ''
            const f = str.charAt(0)
                .toUpperCase()
            return f + str.substr(1)
        },
        StartCase(_f) {
            const e = this.ucwords(_.toLower(_f))

            return e
        },
        PDFtoImage() {
            const parent = document.getElementById('pdfcard')
            const canvas = parent.querySelectorAll('canvas')

            if(canvas.length > 0){
                // console.log(canvas[0].toDataURL("image/png"))
                var a = document.createElement("a")
                a.href = canvas[0].toDataURL("image/png")
                a.setAttribute("download", `Citizen-QR-${moment().unix()}.png`)
                a.click()
                document.removeChild(a)
            }
        },
        LoadSig() {
            if(!this.uploadsignature){
                this.LoadSignature()
            }
        },
        PDFLoaded(event) {
            this.pdf.currentPage = event

            this.pdfloaded = true
        },
        PDFViewer(file) {
            this.pdf.media = `${this.domain}/${file.replace('public/files', 'serve/staticfiles')}`
            this.pdf.show = true
        },
        PrintCard() {
            this.overlay = true
            this.pdfloaded = false

            axios({
                method: 'post',
                url: `${this.domain}/crm_citizen_card_id`,
                data: {
                    citizenid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        setTimeout(() => {
                            this.overlay = false

                            this.PDFViewer(response.data.filename)
                        }, 1500)
                    } else{
                        this.overlay = false
                    }
                })
        },
        PrintID() {
            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/crm_citizen_print_id`,
                data: {
                    citizenid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        setTimeout(() => {
                            this.overlay = false

                            this.PDFViewer(response.data.filename)
                        }, 1500)
                    } else{
                        this.overlay = false
                    }
                })
        },
        PermanentAddressDragend() {
            console.log(this.citizen.address.permanent.latlng)
        },
        LoadedProfilePic() {
            this.profilepicloaded = true

            this.ComputeProfilePerc()
        },
        LoadedValidId() {
            this.valididpicloaded = true

            this.ComputeProfilePerc()
        },
        ViewProfilePhoto(img) {
            const _img = `${this.domain}/serve/staticfiles/${img.replace('public/files/', '')}`

            this.lightboxmedia = [{
                thumb: _img,
                src: _img,
            }]

            this.$refs.lightbox.showImage(0)
        },
        // signature
        CropPhotoSignature({ coordinates, canvas, }) {
			this.croppedsigphoto.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image, that can be used 
			// as src for <img/> to preview result
			this.croppedsigphoto.dataurl = canvas.toDataURL()
        },
        // new crop photo
        CropPhoto({ coordinates, canvas, }) {
			this.croppedphoto.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image, that can be used 
			// as src for <img/> to preview result
			this.croppedphoto.dataurl = canvas.toDataURL()
        },
        SelectCroppedSignaturePhoto() {
            this.citizenssignaturedata = this.croppedsigphoto.dataurl

            this.cropsigform = false
        },
        SelectCroppedPhoto() {
            this.cropform = false
        },
        async FileAttachmentUploadedSignature(file) {
            this.citizenssignaturedata = ''

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            toBase64(file).then(mfile => {
                this.citizenssignaturedata = mfile

                this.cropsigform = true
            }).catch(() => {

            })
        },
        // new valid id
        async FileAttachmentValidId(file) {
            this.citizen.cphotovalididdata = ''

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            toBase64(file).then(mfile => {
                this.citizen.cphotovalididdata = mfile

                this.imgvalidid = mfile
            }).catch(() => {

            })
        },
        async FileAttachment(file) {
            this.citizen.cphotodata = ''

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            toBase64(file).then(mfile => {
                this.citizen.cphotodata = mfile

                this.img = mfile

                this.cropform = true
            }).catch(() => {

            })
        },
        PhoneNumberUpdateRep({number, isValid}) {
            this.citizen.representative.mobilevalid = isValid
            this.citizen.representative.mobileformatted = number.e164
        },
        async FileAttachmentSEC(files) {
            this.citizen.secdtidata = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (let file of files) {
                toBase64(file).then(mfile => {
                    this.citizen.secdtidata.push(mfile)
                }).catch(() => {

                })
            }
        },
        async FileAttachmentAuthRep(files) {
            this.citizen.boardresolutionauthorizingrepdata = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (let file of files) {
                toBase64(file).then(mfile => {
                    this.citizen.boardresolutionauthorizingrepdata.push(mfile)
                }).catch(() => {

                })
            }
        },
        UndoSig() {
            this.$refs.signaturePad.undoSignature()
        },
        ClearSig() {
            this.$refs.signaturePad.clearSignature()
        },
        SaveProcessDisabled() {
            const permanent = this.citizen.address.permanent.istugue ? this.citizen.address.permanent.brgy.toString().length > 0 && this.citizen.address.permanent.street.toString().length > 0 : this.citizen.address.permanent.address1.toString().length > 0 && this.citizen.address.permanent.city.toString().length > 0 && this.citizen.address.permanent.province.toString().length > 0 && this.citizen.address.permanent.country.toString().length > 0

            const present = this.citizen.address.present.istugue ? this.citizen.address.present.brgy.toString().length > 0 && this.citizen.address.present.street.toString().length > 0 : this.citizen.address.present.address1.toString().length > 0 && this.citizen.address.present.city.toString().length > 0 && this.citizen.address.present.province.toString().length > 0 && this.citizen.address.present.country.toString().length > 0

            let spouse = false

            if(this.citizen.civil_status.toString().toUpperCase() == 'M'){
                if(this.citizen.spousename.toString().length > 0){
                    spouse = true
                }
            } else{
                spouse = true
            }

            if(this.citizen.accounttype.toString() == 'individual'){
                return (
                    this.citizen.mobile.toString().length > 0
                    && this.citizen.username.toString().length > 0
                    // && this.citizen.fathers_name.toString().length > 0
                    // && this.citizen.mothers_maiden_name.toString().length > 0
                    && permanent
                    && present
                    && this.citizen.firstname.toString().length > 0
                    && this.citizen.middlename.toString().length > 0
                    && this.citizen.lastname.toString().length > 0
                    && this.citizen.birthdate.toString().length > 0
                    && this.citizen.gender.toString().length > 0
                    && this.citizen.birthplace.toString().length > 0
                    && this.citizen.email.toString().length > 0
                    // && this.citizen.nationality.toString().length > 0
                    && spouse
                ) == false
            } else{
                return (
                    this.citizen.mobile.toString().length > 0
                    && this.citizen.username.toString().length > 0
                    && this.citizen.companyname.toString().length > 0
                    && this.citizen.businesstype.toString().length > 0
                    && this.citizen.representative.name.toString().length > 0
                    && this.citizen.representative.email.toString().length > 0
                    && this.citizen.representative.contactnumber.toString().length > 0
                    && this.citizen.email.toString().length > 0
                    && this.citizen.tin.toString().length > 0
                    && permanent
                    && present
                ) == false
            }
        },
        ResetAll() {
            this.citizen = _.cloneDeep(this.citizenreset)

            this.LoadSignature()
            this.signatureloaded = false
        },
        lookupBrgy() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_lookup_brgy`,
                data: {}
            })
                .then(response => {
                    this.overlay = false
                    
                    if(response.data.response){
                        this.brgy = response.data.brgy
                    }
                })
        },
        PhoneNumberUpdate({ number, isValid }) {
            this.citizen.mobilevalid = isValid
            this.citizen.mobileformatted = number.e164
        },
        FullnameFormat() {
            let format1 = []
            let format2 = []

            if(this.citizen.firstname.toString().length > 0){
                format1.push(this.citizen.firstname.toString())
            }

            if(this.citizen.middlename.toString().length > 0){
                format1.push(this.citizen.middlename.toString())
            }

            if(this.citizen.lastname.toString().length > 0){
                format1.push(this.citizen.lastname.toString())
            }

            if(this.citizen.extensionname.toString().length > 0){
                format1.push(this.citizen.extensionname.toString())
            }

            if(this.citizen.lastname.toString().length > 0){
                format2.push(this.citizen.lastname.toString())
            }

            if(this.citizen.extensionname.toString().length > 0){
                format2.push(` ${this.citizen.extensionname.toString()}`)
            }

            if(this.citizen.firstname.toString().length > 0){
                if(format2.length == 0){
                    format2.push(this.citizen.firstname.toString())
                } else{
                    format2.push(`, ${this.citizen.firstname.toString()}`)
                }
            }

            if(this.citizen.middlename.toString().length > 0){
                format2.push(` ${this.citizen.middlename.toString()}`)
            }

            this.citizen.fullname_format1 = format1.join(' ')
            this.citizen.fullname_format2 = format2.join('')
        },
        CopyPermanentAddress() {
            this.citizen.address.present = _.cloneDeep(this.citizen.address.permanent)

            // this.center2 = this.citizen.address.present.latlng
        },
        onreadymap() {
            this.map = this.$refs.myMap.mapObject
            this.map2 = this.$refs.myMap2.mapObject
        },
        ReverseGeocoderPresent() {
            const geocoder = new Nominatim()
            let address = []

            if(this.citizen.address.present.istugue){
                if(this.citizen.address.present.street.toString().length > 0){
                    address.push(this.citizen.address.present.street.toString())
                }

                const barangay = this.brgy.filter(x => {
                    return parseInt(x.BarangayCode) == parseInt(this.citizen.address.present.brgy)
                })

                if(barangay.length > 0){
                    address.push(barangay[0].BarangayName.toString())
                }
            } else{
                address.push(this.citizen.address.present.address1.toString())
                address.push(this.citizen.address.present.address2.toString())
            }

            address.push(this.citizen.address.present.city.toString())
            address.push(this.citizen.address.present.province.toString())
            address.push(this.citizen.address.present.zipcode.toString())
            address.push(this.citizen.address.present.country.toString())

            geocoder.search( { q: address.join(', ') } )
                .then((response) => {
                    if(response.length > 0){
                        this.citizen.address.present.latlng = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                        // this.center2 = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                    } else{
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                    }
                })
                .catch(() => {
                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                })
        },
        ReverseGeocoderPermanent() {
            const geocoder = new Nominatim()
            let address = []

            if(this.citizen.address.permanent.istugue){
                if(this.citizen.address.permanent.street.toString().length > 0){
                    address.push(this.citizen.address.permanent.street.toString())
                }

                const barangay = this.brgy.filter(x => {
                    return parseInt(x.BarangayCode) == parseInt(this.citizen.address.permanent.brgy)
                })

                if(barangay.length > 0){
                    address.push(barangay[0].BarangayName.toString())
                }
            } else{
                address.push(this.citizen.address.permanent.address1.toString())
                address.push(this.citizen.address.permanent.address2.toString())
            }

            address.push(this.citizen.address.permanent.city.toString())
            address.push(this.citizen.address.permanent.province.toString())
            address.push(this.citizen.address.permanent.zipcode.toString())
            address.push(this.citizen.address.permanent.country.toString())

            geocoder.search( { q: address.join(', ') } )
                .then((response) => {
                    if(response.length > 0){
                        this.citizen.address.permanent.latlng = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                        this.center = [ parseFloat(response[0].lat), parseFloat(response[0].lon) ]
                    } else{
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                    }
                })
                .catch(() => {
                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Geocoder found no result for address - ${address.join(', ')}`
                })
        },
        PresentAddressChange() {
            this.citizen.address.present.address1 = ''
            this.citizen.address.present.address2 = ''
            this.citizen.address.present.latlng = [ 17.611138, 121.7257458 ]
            this.citizen.address.present.zoom = 13
            this.citizen.address.present.brgy = ''
            this.citizen.address.present.street = ''

            if(this.citizen.address.present.istugue){
                this.citizen.address.present.city = 'Tuguegarao City'
                this.citizen.address.present.province = 'Cagayan'
                this.citizen.address.present.country = 'Philippines'
                this.citizen.address.present.zipcode = 3500
                this.center2 = [ 17.611138, 121.7257458 ]
                this.MapInvalidateSize()
            } else{
                this.citizen.address.present.city = 'Tuguegarao City'
                this.citizen.address.present.province = 'Cagayan'
                this.citizen.address.present.country = 'Philippines'
                this.citizen.address.present.zipcode = 3500
            }
        },
        PermanentAddressChange() {
            this.citizen.address.permanent.address1 = ''
            this.citizen.address.permanent.address2 = ''
            this.citizen.address.permanent.latlng = [ 17.611138, 121.7257458 ]
            this.citizen.address.permanent.zoom = 13
            this.citizen.address.permanent.brgy = ''
            this.citizen.address.permanent.street = ''

            if(this.citizen.address.permanent.istugue){
                this.citizen.address.permanent.city = 'Tuguegarao City'
                this.citizen.address.permanent.province = 'Cagayan'
                this.citizen.address.permanent.country = 'Philippines'
                this.citizen.address.permanent.zipcode = 3500
                this.center = [ 17.611138, 121.7257458 ]
                this.MapInvalidateSize()
            } else{
                this.citizen.address.permanent.city = 'Tuguegarao City'
                this.citizen.address.permanent.province = 'Cagayan'
                this.citizen.address.permanent.country = 'Philippines'
                this.citizen.address.permanent.zipcode = 3500
            }
        },
        MapInvalidateSize() {
            setTimeout(() => {
                if(parseInt(this.active_tab) == 2){
                    this.$refs.myMap.mapObject.invalidateSize()
                    // this.$refs.myMap2.mapObject.invalidateSize()

                    this.center = this.citizen.address.permanent.latlng
                    // this.center2 = this.citizen.address.present.latlng
                }

                if(parseInt(this.active_tab) == 4 && !this.signatureloaded){
                    this.signatureloaded = true
                    this.LoadSignature()
                }
            }, 100)
        },
        ChangeMyPassword() {
            if(this.password.toString() != this.confirmpassword.toString()){
                this.showSnackbar = true
                this.snackbarVariant = 'red darken-3'
                this.modalMessage = `Passwords do not match`

                return false
            }

            if(this.password.toString().length < 6){
                this.showSnackbar = true
                this.snackbarVariant = 'red darken-3'
                this.modalMessage = `Password is too short, create a password with at least 6 characters`

                return false
            }

            const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
            // double decode
            const decodedpass = this.$jwt.decode(user.passwd, this.jwtsecret)

            if(this.password.toString() == decodedpass.password.toString()){
                this.showSnackbar = true
                this.snackbarVariant = 'red darken-3'
                this.modalMessage = `New Password is same as Old Password`

                return false
            }

            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_change_password`,
                data: {
                    _id: user._id.toString(),
                    password: this.password.toString()
                }
            })
                .then(response => {
                    this.overlay = false
                    this.showSnackbar = true

                    if(response.data.response){
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'New Password has been saved'

                        const { user } = this.$jwt.decode(response.data.jwt, this.jwtsecret)
                        this.citizen = _.cloneDeep(user)
                        this.citizenreset = _.cloneDeep(user)
                        this.$session.set('crmusersessionsignature', response.data.jwt)

                        this.$emit('updatesession', true)
                    } else{
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message.toString()
                    }
                })
        },
        SaveProcess() {
            const { isEmpty, data } = this.$refs.signaturePad ? this.$refs.signaturePad.saveSignature() : {
                isEmpty: true,
                data: undefined
            }

            // if(isEmpty && this.citizen.accounttype.toString() == 'individual'){
            //     this.showSnackbar = true
            //     this.snackbarVariant = 'red darken-3'
            //     this.modalMessage = `You need to add your Signature`

            //     return false
            // }

            if(this.citizen.mobilevalid == false){
                this.showSnackbar = true
                this.snackbarVariant = 'red darken-3'
                this.modalMessage = `Invalid Mobile Number`

                return false
            }

            this.overlay = true

            const citizenD = _.cloneDeep(this.citizen)
            delete citizenD.imgUrl
            delete citizenD.status

            if(!isEmpty){
                citizenD.signature = data.toString()
            }

            if(citizenD.accounttype.toString() == 'individual'){
                citizenD.secdti = []
                citizenD.secdtidata = []
                citizenD.boardresolutionauthorizingrep = []
                citizenD.boardresolutionauthorizingrepdata = []
            }

            citizenD.secdtidata = JSON.stringify(citizenD.secdtidata)
            citizenD.boardresolutionauthorizingrepdata = JSON.stringify(citizenD.boardresolutionauthorizingrepdata)
            citizenD.mobile = citizenD.mobileformatted
            citizenD.representative.contactnumber = citizenD.representative.mobileformatted

            citizenD.imgUrl = this.croppedphoto.dataurl ? this.croppedphoto.dataurl.toString() : ''
            
            delete citizenD.cphoto
            delete citizenD.cphotodata

            citizenD.imgUrlValidId = citizenD.cphotovalididdata ? citizenD.cphotovalididdata.toString() : ''

            delete citizenD.cphotovalidid
            delete citizenD.cphotovalididdata

            // console.log(this.citizen)
            citizenD.address.permanent.latlng = [parseFloat(this.citizen.address.permanent.latlng.lat), parseFloat(this.citizen.address.permanent.latlng.lng)]

            if(this.uploadsignature && this.citizenssignaturedata.toString().length > 0){
                citizenD.signature = this.citizenssignaturedata.toString()
            }

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_citizen_process`,
                data: citizenD
            })
                .then(response => {
                    this.overlay = false
                    this.showSnackbar = true

                    if(response.data.response){
                        this.snackbarVariant = 'green darken-3'
                        this.modalMessage = 'Your Profile Details has been saved'

                        const { user } = this.$jwt.decode(response.data.jwt, this.jwtsecret)

                        delete user.signature
                        delete user.passwd
                        this.citizen = _.cloneDeep(user)

                        this.citizen.secdti = []
                        this.citizen.secdtidata = []
                        this.citizen.boardresolutionauthorizingrep = []
                        this.citizen.boardresolutionauthorizingrepdata = []

                        this.citizenreset = _.cloneDeep(this.citizen)
                        this.$session.set('crmusersessionsignature', response.data.jwt)

                        this.$emit('updatesession', true)

                        this.profilepic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrl.replace('public/files/', '')}`
                        this.valididpic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrlValidId.replace('public/files/', '')}`

                        setTimeout(() => {
                            this.ComputeProfilePerc()
                        }, 3000)
                    } else{
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message.toString()
                    }
                })

            // console.log(this.citizen)
        },
        async LoadSignature() {
            if(this.citizen.signatureloc && this.citizen.signatureloc.toString().length > 0){
                // let blob = await fetch(`${this.domain}/serve/staticimages/${this.citizen.signatureloc.replace('images/', '')}`).then(r => r.blob())
                let blob = await fetch(`${this.domain}/serve/staticimages/${this.citizen.signatureloc.replace('public/images/', '')}`).then(r => r.blob())


                let dataUrl = await new Promise(resolve => {
                    let reader = new FileReader();
                    reader.onload = () => resolve(reader.result)
                    reader.readAsDataURL(blob)
                })
                
                this.$refs.signaturePad.fromDataURL(dataUrl)
            }
        },
        ComputeProfilePerc() {
            let totalChecked = 0
            let totalFields = 0
            // const toCheck = this.citizen.accounttype.toString() == 'individual' ? ['username', 'firstname', 'middlename', 'lastname', 'gender', 'birthdate', 'mobile', 'email', 'fathers_name', 'mothers_maiden_name', 'civil_status', 'nationality', 'tin', 'birthplace', 'occupation', 'educational_attainment', 'signatureloc'] : ['username', 'companyname', 'businesstype', 'date_established', 'tin', 'signatureloc']
            const toCheck = this.citizen.accounttype.toString() == 'individual' ? ['username', 'firstname', 'middlename', 'lastname', 'gender', 'birthdate', 'mobile', 'email', 'civil_status', 'nationality', 'tin', 'birthplace', 'occupation', 'signatureloc'] : ['username', 'companyname', 'businesstype', 'date_established', 'tin', 'signatureloc']

            totalFields = toCheck.length

            toCheck.forEach(x => {
                if(this.citizen[x] && this.citizen[x].toString().length > 0){
                    totalChecked++
                }
            })

            totalFields += 11

            if(this.citizen.address.permanent.street && this.citizen.address.permanent.street.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.permanent.brgy && this.citizen.address.permanent.brgy.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.address1 && this.citizen.address.present.address1.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.address2 && this.citizen.address.present.address2.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.city && this.citizen.address.present.city.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.province && this.citizen.address.present.province.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.country && this.citizen.address.present.country.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.zipcode && this.citizen.address.present.zipcode.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.name && this.citizen.incaseofemergency.name.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.address && this.citizen.incaseofemergency.address.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.contactnumber && this.citizen.incaseofemergency.contactnumber.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.accounttype.toString() != 'individual'){
                totalFields += 5

                if(this.citizen.representative && this.citizen.representative.name && this.citizen.representative.name.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.representative && this.citizen.representative.address && this.citizen.representative.address.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.representative && this.citizen.representative.contactnumber && this.citizen.representative.contactnumber.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.secdti && this.citizen.secdti.length > 0){
                    totalChecked++
                }

                if(this.citizen.boardresolutionauthorizingrep && this.citizen.boardresolutionauthorizingrep.length > 0){
                    totalChecked++
                }
            }

            totalFields+=2

            if(this.profilepicloaded){
                totalChecked++
            }

            if(this.valididpicloaded){
                totalChecked++
            }

            // console.log(`${totalChecked} ${totalFields}`)

            this.profileperc = Math.abs( Math.round( (totalChecked / totalFields) * 100 ) )
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // console.log(this.citizen)

        if(!this.citizen.birthplace){
            this.citizen.birthplace = ''
        }

        if(!this.citizen.spousename){
            this.citizen.spousename = ''
        }

        if(!this.citizen.occupation){
            this.citizen.occupation = ''
        }

        if(!this.citizen.educational_attainment){
            this.citizen.educational_attainment = ''
        }

        if(!this.citizen.extensionname){
            this.citizen.extensionname = ''
        }

        if(!this.citizen.incaseofemergency){
            this.citizen.incaseofemergency = {
                name: '',
                address: '',
                contactnumber: '',
            }
        }

        if(this.citizen.date_established.toString().length == 0){
            this.citizen.date_established = moment().toISOString().substr(0, 10)
        }

        this.citizen.secdti = []
        this.citizen.secdtidata = []
        this.citizen.boardresolutionauthorizingrep = []
        this.citizen.boardresolutionauthorizingrepdata = []

        this.citizen.tugueresident = this.citizen.tugueresident || false

        this.citizenreset = _.cloneDeep(this.citizen)

        this.lookupBrgy()

        this.citizen.address.present.istugue = false

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        if(this.citizen.imgUrl){
            this.profilepic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrl.replace('public/files/', '')}`
        }

        if(this.citizen.imgUrlValidId){
            this.valididpic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrlValidId.replace('public/files/', '')}`
        }

        if(!this.citizen.address.permanent.latlng[0] || !this.citizen.address.permanent.latlng[1]){
            this.citizen.address.permanent.latlng = [ 17.611138, 121.7257458 ]
        }

        setTimeout(() => {
            this.ComputeProfilePerc()
        }, 3000)

        if(this.$route.query.tab){
            switch(this.$route.query.tab.toString()) {
                case 'info':
                    this.active_tab = 0
                    break;
                case 'password':
                    this.active_tab = 1
                    break;
                case 'address':
                    this.active_tab = 2
                    break;
                case 'other':
                    this.active_tab = 3
                    break;
                case 'signature':
                    this.active_tab = 4

                    setTimeout(() => {
                        this.LoadSignature()
                    }, 1000)
                    break;
            }
        }
    },
    beforeCreate() {
        if (!this.$session.exists()) {
            this.$router.push('/')
        } else{
            if(this.$session.get('crmusersessionsignature')){
                this.$emit('updatesession', true)
            } else{
                this.$router.push('/')
            }
        }
    }
}
</script>